const state = {
	segmentsCount: null,
	projectSegmentsCount: [],
	projectSegmentsTotal: null,
	problematicSegments: [],
	problematicTotal: null
}

export default state
